// extracted by mini-css-extract-plugin
export default {"tableScrollBarStyle":"TableComponent_tableScrollBarStyle__FfxWh"};